import { User } from '../../../graphql.generated';

const UNSAVED_STORAGE_KEY = 'unsavedSituationAnswers';

export const shouldShowYourSituation = (
    user?: Partial<User> | null,
    isNewlyRegistered?: boolean
) => {
    if (sessionStorage.getItem(UNSAVED_STORAGE_KEY)) {
        return false;
    }

    if (!user || isNewlyRegistered) {
        return true;
    }

    if (
        typeof user.profile?.situationWhatIsYourCurrentPropertyGoal === 'string'
    ) {
        return false;
    }

    if (user.traits?.yourSituationSkipped) {
        return false;
    }

    return true;
};
